import React, { useState, useRef,useEffect } from "react";
import "./ChatToggle.css";
import { useChatContext } from "../../Context/ChatContext";
import iconBot from "../../Assets/chat/BotAvatarOrange.png";

interface ChatToggleProps {
  setIsOpenbot: (isOpen: boolean) => void;
}

const ChatToggle: React.FC<ChatToggleProps> = ({ setIsOpenbot }) => {
  const [open, setOpen] = useState(false);
  const [showVibration, setShowVibration] = useState(false);
  const fireworksRef = useRef<HTMLDivElement>(null);

  const toggleChat = () => {
    const newValue = !open;
    setOpen(newValue);
    setIsOpenbot(newValue);
  };

  const [localInput, setLocalInput] = useState("");
  const { setInputText, setTriggerSubmit } = useChatContext();

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter" && localInput.trim() !== "") {
      toggleChat();
      setInputText(localInput); // Envía el texto al context

      setTimeout(() => {
        setTriggerSubmit(true); // dispara el envío
      }, 3000); // Limpia el input local
    }
  };


  return (
    <>
      <div
        className="d-flex align-items-center rounded border px-2 py-1 chat-container"
        style={{ backgroundColor: "#061848" }}
      >
        {/* Icono a la izquierda */}
        <div className="bg-white rounded d-flex justify-content-start align-items-center me-2 w-100">
        <span className="mx-2 text-warning" style={{ position: "relative" }}>
  {/* Fuegos artificiales arriba del icono */}
  <div className="fireworks-overlay" ref={fireworksRef}></div>

  <div className="bot-icon-wrapper">
    <img
      src={iconBot}
      alt="Bot icon"
      width={25}
      className={showVibration ? "vibrate-icon" : ""}
    />
    <span className="ping-wave" />
  </div>
</span>


          {/* Input */}
          <input
            type="text"
            className="form-control border-0 shadow-none "
            placeholder="Ask me about your economics data..."
            style={{ width: "300px" }}
            value={localInput}
            onChange={(e) => setLocalInput(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </div>

        {/* Botón con flechita */}
        <button
          className="btn text-white chat-toggle-button "
          onClick={toggleChat}
          style={{ width: 20 }}
        >
          <span className={`arrow ${open ? "up" : "down"}`} />
        </button>
      </div>
      {/* <div className="chat-container">
        
      <button className="chat-toggle-button" onClick={toggleChat}>
        Ask me about the data you want…
        <span className={`arrow ${open ? 'up' : 'down'}`} />
      </button>
    </div> */}
    </>
  );
};

export default ChatToggle;
